import { includes } from 'lodash';

export const oneOf = (value: $TSFixMe, ...items: $TSFixMe[]) => includes(items, value);

export const swap = <T>(prevIndex: number, newIndex: number, array: Array<T> = []) => {
    if (prevIndex < 0 || newIndex < 0 || prevIndex > array.length - 1 || newIndex > array.length - 1) {
        return array;
    }

    const newArray = [...array];

    [newArray[prevIndex], newArray[newIndex]] = [array[newIndex], array[prevIndex]];

    return newArray;
};
